import React from "react";
import { RULES, TAGS } from "../../../constants/rules";
import { messages } from "../../../constants/intl";
import { generateSectionConfig } from "@carrier-ecat/ngecat-commonworkflowui";
import { InputRange } from "@carrier-ecat/ngecat-tsreactcomponents";
import Tune from '@material-ui/icons/Tune';
const targetRequirements = generateSectionConfig(RULES, [TAGS.UI_SEL, TAGS.UI_SEL_DC, TAGS.UI_SEL_DC_REQS], {
    label: 'Target Requirements',
    id: 'section-model',
    icon: () => React.createElement(Tune, null),
    components: [{
            size: 12,
            cells: [
                {
                    rule: { name: RULES.UI_SEL_DC_REQS.DC_NTARGETCAPACITY },
                    component: React.createElement(InputRange, { useMinMaxIfOutOfRange: true })
                },
                {
                    rule: { name: RULES.UI_SEL_DC_REQS.DC_NMINCAPACITYMARGIN },
                    component: React.createElement(InputRange, { label: messages.DC_NMINCAPACITYMARGIN.defaultMessage }),
                },
                {
                    rule: { name: RULES.UI_SEL_DC_REQS.DC_FMINFLOWRATEPERCAPACITY },
                    component: React.createElement(InputRange, { label: messages.DC_FMINFLOWRATEPERCAPACITY.defaultMessage })
                },
            ]
        },
    ]
});
export default targetRequirements;
